export default "__VITE_ASSET__BNa4ismK__"